export default "__VITE_ASSET__BxrEhfX4__"